import { environment } from '@environments/environment';

export const energyOptimizationLink = `${environment.appUri}/energy-optimization?referrer=:realEstateAgentId:&referrerType=realEstateAgent`;
export const copyToClipboardSuccessLabel = 'COPIED_TO_CLIPBOARD';
